import { call, put, takeEvery } from "redux-saga/effects";
import { chuongTrinhDaoTaoApi } from "../../../api/ctdt/chuongTrinhDaoTaoApi";
import { IChuongTrinhDaoTaoCopyRequest } from "../../../model/request/ctdt/IChuongTrinhDaoTaoCopyRequest";
import { IChuongTrinhDaoTao } from "../../../model/respone/ctdt/IChuongTrinhDaoTao";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eChuongTrinhDaoTaoActionIds, IChuongTrinhDaoTaoActionTypes } from "../../action-types/ctdt/IChuongTrinhDaoTaoActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IChuongTrinhDaoTaoCopyMonRequest } from "../../../model/request/ctdt/IChuongTrinhDaoTaoCopyMonRequest";

export function* chuongTrinhDaoTaoSaga(): any {
    yield takeEvery(eChuongTrinhDaoTaoActionIds.LOAD_START, loadWorker);
    yield takeEvery(eChuongTrinhDaoTaoActionIds.LOAD_ALL_START, loadAllWorker);
    yield takeEvery(eChuongTrinhDaoTaoActionIds.SAVE_START, saveWoker);
    yield takeEvery(eChuongTrinhDaoTaoActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eChuongTrinhDaoTaoActionIds.COPY_START, copyWorker);
    yield takeEvery(eChuongTrinhDaoTaoActionIds.PASTE_CLIPBOARD_DATA_START, pasteClipboardDataWorker);
    yield takeEvery(eChuongTrinhDaoTaoActionIds.UPDATE_TOTAL_TIN_CHI_START, updateTotalTinChiWorker);
    yield takeEvery(eChuongTrinhDaoTaoActionIds.UPDATE_LOCK_STATUS_START, updateLockStatusWorker);
}

function* loadWorker(action: IChuongTrinhDaoTaoActionTypes): any {
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoApi.SelectByNamHocAsync, action.payload as string);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.LOAD_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* loadAllWorker(action: IChuongTrinhDaoTaoActionTypes): any {
    debugger
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.LOAD_ALL_SUCCESS(res.data));
    } else {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.LOAD_ALL_ERROR(res.message ?? "Có lỗi"));
    }
}
function* saveWoker(action: IChuongTrinhDaoTaoActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as IChuongTrinhDaoTao;
    if (payload.id_dt > 0) {
        res = yield call(chuongTrinhDaoTaoApi.Update, payload);
    } else {
        res = yield call(chuongTrinhDaoTaoApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.SAVE_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.SAVE_ERROR(res.message ?? "Có lỗi")
        );
    }

}

function* deleteWorker(action: IChuongTrinhDaoTaoActionTypes): any {
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoApi.Deletes, action.payload as IIdsRequest);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.DELETE_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.DELETE_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* copyWorker(action: IChuongTrinhDaoTaoActionTypes): any {
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoApi.Copy, action.payload as IChuongTrinhDaoTaoCopyRequest);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.COPY_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.COPY_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* pasteClipboardDataWorker(action: IChuongTrinhDaoTaoActionTypes): any {
    const payload = action.payload as IChuongTrinhDaoTaoCopyMonRequest;
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoApi.PasteClipboardData, payload);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.PASTE_CLIPBOARD_DATA_SUCCESS(res.data));
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.LOAD_BY_CTDT_START(payload.id_dt_dich));
    } else {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.PASTE_CLIPBOARD_DATA_ERROR(res.message ?? "Có lỗi"));
    }
}

function* updateTotalTinChiWorker(action: IChuongTrinhDaoTaoActionTypes): any {
    const payload = action.payload as IIdsRequest;
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoApi.UpdateTotalTinChi, payload);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.UPDATE_TOTAL_TIN_CHI_SUCCESS(res.data));
    } else {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.UPDATE_TOTAL_TIN_CHI_ERROR(res.message ?? "Có lỗi"));
    }
}

function* updateLockStatusWorker(action: IChuongTrinhDaoTaoActionTypes): any {
    const payload = action.payload as IChuongTrinhDaoTao;
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoApi.UpdateLockStatus, payload);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.UPDATE_LOCK_STATUS_SUCCESS(res.data));
    } else {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.UPDATE_LOCK_STATUS_ERROR(res.message ?? "Có lỗi"));
    }
}